import styled from 'styled-components';

export const Content = styled.div`
  position: relative;
`;

export const Inner = styled.div`
  position: relative;
  &.error {
    & > div {
      &:first-child {
        border-top: solid 1px #d33d34 !important;
        border-bottom: solid 1px #d33d34 !important;
        background-color: rgba(211, 61, 52, 0.2);
        /* input,
        select, */
        label {
          color: #d33d34 !important;
        }
        input,
        select {
          border-color: #d33d34;
        }
      }
    }
    &.simple {
      & > div {
        &:first-child {
          border-top: none !important;
          border-bottom: none !important;
          background-color: initial;
          label {
            color: #d33d34 !important;
          }
          .input {
            border: solid 1px #d33d34;
            color: #d33d34 !important;
            background-color: rgba(211, 61, 52, 0.2);
          }
        }
      }
    }
  }
`;

export const Message = styled.div`
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10;
  left: 50%;
  transform: translate(-50%, 0);
  bottom: -44px;
  height: 40px;
  min-width: 300px;
  background-color: #d33d34;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.5);
  border-radius: 4px;
  font-size: 15px;
  color: #fff;
  line-height: 1.73;
  width: max-content;
  padding: 0 15px;
  &:before {
    content: '';
    position: absolute;
    background-color: #d33d34;
    top: -3px;
    width: 18px;
    height: 18px;
    border-bottom-right-radius: 100%;
    left: 50%;
    transform: rotate(45deg) translate(-50%, 0);
  }
  &.as-filter {
    left: 0;
    transform: none;
    &:before {
      left: 25%;
    }
  }
`;
